// Pomocné funkcie pre prácu s dátumami.
// Všetky dátumy sa interne reprezentujú ako reťazec 'YYYY-MM-DD' (lokálny čas).

export function toKey(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function fromKey(key) {
  const [y, m, d] = key.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(date, days) {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + days);
  return copy;
}

export function todayKey() {
  return toKey(new Date());
}

/** Rozdiel dvoch dátumov v dňoch (bez zahrnutia posledného dňa). */
export function diffDays(startKey, endKey) {
  const ms = fromKey(endKey) - fromKey(startKey);
  return Math.round(ms / 86400000);
}

/**
 * Pole kľúčov dátumov od start po end – OBA vrátane.
 * Prenájom sa účtuje za každý kalendárny deň, aj prvý a posledný
 * (piatok–nedeľa = 3 platené dni).
 */
export function eachDayInclusive(startKey, endKey) {
  const days = [];
  let cursor = fromKey(startKey);
  const end = fromKey(endKey);
  while (cursor <= end) {
    days.push(toKey(cursor));
    cursor = addDays(cursor, 1);
  }
  return days;
}

const MONTHS_SK = [
  'január', 'február', 'marec', 'apríl', 'máj', 'jún',
  'júl', 'august', 'september', 'október', 'november', 'december',
];

const MONTHS_SK_GENITIVE = [
  'januára', 'februára', 'marca', 'apríla', 'mája', 'júna',
  'júla', 'augusta', 'septembra', 'októbra', 'novembra', 'decembra',
];

export const WEEKDAYS_SK_SHORT = ['Po', 'Ut', 'St', 'Št', 'Pi', 'So', 'Ne'];

export function monthLabelSk(date) {
  return `${MONTHS_SK[date.getMonth()]} ${date.getFullYear()}`;
}

/** Napr. '15. augusta 2026' */
export function formatDateSk(key, withYear = true) {
  const date = fromKey(key);
  const base = `${date.getDate()}. ${MONTHS_SK_GENITIVE[date.getMonth()]}`;
  return withYear ? `${base} ${date.getFullYear()}` : base;
}

/** Skloňovanie: 1 deň, 2–4 dni, 5+ dní */
export function daysLabelSk(n) {
  if (n === 1) return '1 deň';
  if (n >= 2 && n <= 4) return `${n} dni`;
  return `${n} dní`;
}
